import { useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { useQueryClient } from 'react-query';
import { trackLogout } from 'analytics/ga4';
import { clearAuthSession } from 'utils/clearAuthSession';

export default function ExitPage () {

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {

    trackLogout();
    clearAuthSession();
    // Drop all cached user data (orgs/farms/account) so the next login cannot show the previous user.
    queryClient.clear();
    navigate("/");

  }, [navigate, queryClient])

  return (<></>)

}
